import { useMutation } from "@tanstack/react-query";
import { supabase } from "../lib/supabase";

export interface RealEstateEstimateData {
  address: string;
}

export interface VehicleEstimateData {
  year: number;
  make: string;
  model: string;
  condition: "excellent" | "good" | "fair" | "poor";
  mileage?: number;
}

export interface EstimateResult {
  estimatedValue: number;
  suggestedItemName: string;
  suggestedItemType?: string;
}

interface EstimateRequest {
  estateId: number;
  assetType: "real-estate" | "vehicle";
  data: RealEstateEstimateData | VehicleEstimateData;
}

export function useAssetEstimate() {
  return useMutation({
    mutationFn: async (request: EstimateRequest): Promise<EstimateResult> => {
      const { estateId, ...bodyData } = request;
      const { data, error } = await supabase.functions.invoke(
        `financials/${estateId}/items/estimate`,
        {
          body: bodyData,
        },
      );

      if (error) {
        throw new Error(error.message || "Failed to estimate asset value");
      }

      if (!data) {
        throw new Error("No data returned from estimation");
      }

      return data as EstimateResult;
    },
  });
}
